var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.45,1.49a11.38,11.38,0,0,0-9.19,18.1L2.61,26.93a1.5,1.5,0,0,0,1,2.58,1.48,1.48,0,0,0,1-.42l7.64-7.33A11.39,11.39,0,1,0,19.45,1.49Zm0,19.79a8.4,8.4,0,1,1,8.4-8.39A8.41,8.41,0,0,1,19.45,21.28Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndice);
export default __webpack_public_path__ + "static/media/indice.668ca4a410e51e7b98878c681e94a9aa.svg";
export { ForwardRef as ReactComponent };